// @flow
import * as React from 'react';
import SearchView from 'containers/search';
import { QuestionFieldsets } from './SearchForm';

export default class QuestionSearch extends React.PureComponent<*> {
  static label = 'Native Questions';

  render() {
    return (
      <SearchView
        label={QuestionSearch.label}
        primaryFieldsets={QuestionFieldsets.primaryFieldsets}
        extraFieldsets={QuestionFieldsets.extraFieldsets}
        {...this.props}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/search/Questions.js